"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _effect = _interopRequireDefault(require("./effect"));
var _api = require("./api");
var _vue = _interopRequireDefault(require("vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WelfareCardPackage',
  data: function data() {
    return {
      selectedCards: null,
      switchValue: true,
      exchangePageOptions: [],
      localCardList: [],
      // Local backup for card list
      tableRowStyle: {
        borderBottom: '1px solid #EBEEF5',
        padding: '12px 0',
        fontSize: '13px',
        color: '#606266'
      },
      tableHeaderStyle: {
        background: '#f5f7fa',
        color: '#606266',
        borderBottom: '1px solid #EBEEF5',
        fontWeight: '500',
        fontSize: '13px',
        padding: '12px 0'
      },
      // 默认主题色
      defaultThemeColor: '',
      // Include cardList property as a fallback
      cardList: [],
      exchangeConfigsLoading: false,
      exchangePageTotal: 0,
      exchangePageParams: {
        page: 1,
        limit: 10
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, _effect.default.computed), {}, {
    // Debug property to check cardList availability
    debugCardList: function debugCardList() {
      // Get cardList from effect.js, ensuring it's an array
      var effectCardList = Array.isArray(this.cardList) ? this.cardList : [];
      // Use local card list if mixin's cardList is empty
      var list = effectCardList.length > 0 ? effectCardList : this.localCardList || [];

      // Make sure IDs are numbers to match correctly with cardIds array
      var result = list.map(function (card) {
        return {
          id: Number(card.id),
          name: card.name || "".concat(card.id, " - \u5361\u7247").concat(card.id)
        };
      });
      console.log('Available cards for selection:', result);
      return result;
    }
  }),
  watch: {
    switchValue: {
      handler: function handler(val) {
        this.form.status = val ? 1 : 0;
      },
      immediate: true
    },
    'form.status': {
      handler: function handler(val) {
        this.switchValue = val === 1;
      }
    }
  },
  mounted: function mounted() {
    // Only fetch package list on mount, not card list
    if (this.getList) {
      this.getList();
    }
  },
  methods: _objectSpread(_objectSpread({}, _effect.default.methods), {}, {
    // Local method to fetch cards directly
    fetchCards: function () {
      var _fetchCards = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              console.log('Fetching cards directly...');
              _context.n = 1;
              return (0, _api.getCardsApi)();
            case 1:
              res = _context.v;
              if (res && res.data) {
                if (Array.isArray(res.data)) {
                  this.localCardList = res.data.map(function (card) {
                    return {
                      id: card.id,
                      name: card.cardName
                    };
                  });
                  console.log('Local card list populated:', this.localCardList.length);
                } else {
                  console.error('Card data is not an array:', res.data);
                  this.localCardList = [];
                }
              } else {
                console.error('Failed to fetch cards directly:', res);
                this.localCardList = [];
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('Error fetching cards directly:', _t);
              this.localCardList = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchCards() {
        return _fetchCards.apply(this, arguments);
      }
      return fetchCards;
    }(),
    // 重写打开编辑对话框，添加扩展字段
    openEditDialog: function () {
      var _openEditDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _this = this;
        var _yield$Promise$all, _yield$Promise$all2, cardsResponse, packageDetailResponse, detail, cardStyle, prefix, cardIds, status, hasOption, _cardIds, _status, _cardIds2, _status2, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.dialogTitle = '编辑';
              this.resetForm();
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return Promise.all([(0, _api.getCardsApi)(), (0, _api.getCardPackageDetail)(row.id)]);
            case 2:
              _yield$Promise$all = _context2.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              cardsResponse = _yield$Promise$all2[0];
              packageDetailResponse = _yield$Promise$all2[1];
              // 1. 处理卡片列表数据
              if (cardsResponse && Array.isArray(cardsResponse)) {
                this.localCardList = cardsResponse.map(function (card) {
                  return {
                    id: Number(card.id),
                    name: "".concat(card.id, " - ").concat(card.cardName || card.name || "\u5361\u7247".concat(card.id))
                  };
                });

                // 同时更新effect.js中的cardList
                this.cardList = _toConsumableArray(this.localCardList);
                console.log('Cards loaded successfully:', this.localCardList.length);
              } else {
                console.error('Failed to load cards');
              }

              // 2. 处理卡片包详情数据
              if (!packageDetailResponse) {
                _context2.n = 5;
                break;
              }
              detail = packageDetailResponse; // 直接打印完整的API响应
              console.log('完整API响应:', JSON.stringify(detail));

              // 特别打印关键字段
              console.log('API themeColor:', detail.themeColor);
              console.log('API cardStyle:', detail.cardStyle);

              // 处理图片URL - 去除前缀，与上传保持一致
              cardStyle = detail.cardStyle || '';
              prefix = 'https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/';
              if (cardStyle.startsWith(prefix)) {
                cardStyle = cardStyle.substring(prefix.length);
                console.log('处理后的图片URL:', cardStyle);
              }

              // 使用辅助函数处理cardIds数组
              cardIds = this.processCardIds(detail.cardIds); // 填充表单数据 - 直接使用原始值
              status = parseInt(detail.status || 0);
              this.form = {
                id: detail.id,
                name: detail.name,
                internalName: detail.internalName,
                status: status,
                usageDesc: detail.usageDesc,
                cardIds: cardIds,
                // 扩展字段 - 不添加默认值处理，直接使用原始值
                exchangeConfigId: detail.exchangeConfigId,
                cardStyle: detail.cardStyle,
                themeColor: detail.themeColor || ''
              };

              // 设置开关状态
              this.switchValue = status === 1;

              // 确保界面更新
              this.$nextTick(function () {
                if (_this.form.cardStyle) {
                  console.log('设置卡片样式图片:', _this.form.cardStyle);
                  // 强制更新以确保UI显示
                  _this.$forceUpdate();
                }
              });

              // 如果有exchangeConfigId，确保对应的选项在下拉框中存在
              if (!detail.exchangeConfigId) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return this.loadExchangeConfigs();
            case 3:
              // 如果下拉框中没有对应的选项，添加一个临时选项
              hasOption = this.exchangePageOptions.some(function (opt) {
                return opt.value === detail.exchangeConfigId;
              });
              if (!hasOption && detail.exchangeConfigName) {
                this.exchangePageOptions.push({
                  label: "".concat(detail.exchangeConfigId, "-").concat(detail.exchangeConfigName),
                  value: detail.exchangeConfigId
                });
              }
            case 4:
              _context2.n = 6;
              break;
            case 5:
              // 如果详情API失败，回退到使用行数据
              console.warn('Failed to get package details, using row data');

              // 使用辅助函数处理cardIds
              _cardIds = [];
              if (row.cardIds) {
                _cardIds = this.processCardIds(row.cardIds);
              } else if (row.cards && Array.isArray(row.cards)) {
                _cardIds = row.cards.map(function (card) {
                  return Number(card.id);
                });
              }
              _status = parseInt(row.status || 0);
              this.form = {
                id: row.id,
                name: row.name,
                internalName: row.internalName,
                status: _status,
                usageDesc: row.description,
                cardIds: _cardIds,
                // 扩展字段
                exchangeConfigId: row.exchangeConfigId || null,
                cardStyle: row.cardStyle || '',
                themeColor: row.themeColor || this.defaultThemeColor
              };

              // 设置开关状态
              this.switchValue = _status === 1;

              // 如果有exchangeConfigId，确保对应的选项在下拉框中存在
              if (!row.exchangeConfigId) {
                _context2.n = 6;
                break;
              }
              _context2.n = 6;
              return this.loadExchangeConfigs();
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t2 = _context2.v;
              console.error('Error loading edit data:', _t2);
              this.$message.error('加载卡片包详情失败');

              // 使用辅助函数处理cardIds
              _cardIds2 = [];
              if (row.cardIds) {
                _cardIds2 = this.processCardIds(row.cardIds);
              } else if (row.cards && Array.isArray(row.cards)) {
                _cardIds2 = row.cards.map(function (card) {
                  return Number(card.id);
                });
              }
              _status2 = parseInt(row.status || 0);
              this.form = {
                id: row.id,
                name: row.name,
                internalName: row.internalName,
                status: _status2,
                usageDesc: row.description,
                cardIds: _cardIds2,
                // 扩展字段
                exchangeConfigId: row.exchangeConfigId || null,
                cardStyle: row.cardStyle || '',
                themeColor: row.themeColor || this.defaultThemeColor
              };

              // 设置开关状态
              this.switchValue = _status2 === 1;
            case 8:
              _context2.p = 8;
              this.loading = false;
              this.dialogVisible = true;
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 7, 8, 9]]);
      }));
      function openEditDialog(_x) {
        return _openEditDialog.apply(this, arguments);
      }
      return openEditDialog;
    }(),
    // 重写打开新增对话框，也统一API调用方式
    openAddDialog: function () {
      var _openAddDialog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.dialogTitle = '新增';
              this.resetForm();

              // 仅调用一次获取卡片列表接口
              _context3.p = 1;
              console.log('Fetching cards for add dialog...');
              _context3.n = 2;
              return (0, _api.getCardsApi)();
            case 2:
              res = _context3.v;
              if (res && Array.isArray(res)) {
                // 更新两处的卡片列表
                this.localCardList = res.map(function (card) {
                  return {
                    id: Number(card.id),
                    // 确保ID是数字类型
                    name: "".concat(card.id, " - ").concat(card.cardName || card.name || "\u5361\u7247".concat(card.id))
                  };
                });

                // 同时更新effect.js中的cardList
                this.cardList = _toConsumableArray(this.localCardList);
                console.log('Cards loaded successfully:', this.localCardList.length);
              }

              // 加载兑换页配置列表
              _context3.n = 3;
              return this.loadExchangeConfigs();
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('获取卡片列表失败', _t3);
              this.$message.error('获取卡片列表失败');
            case 5:
              this.dialogVisible = true;
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4]]);
      }));
      function openAddDialog() {
        return _openAddDialog.apply(this, arguments);
      }
      return openAddDialog;
    }(),
    // 重写重置表单，添加扩展字段
    resetForm: function resetForm() {
      this.form = {
        id: '',
        name: '',
        internalName: '',
        status: 1,
        usageDesc: '',
        cardIds: [],
        // 扩展字段
        exchangeConfigId: null,
        cardStyle: '',
        themeColor: this.defaultThemeColor
      };

      // 重置开关状态
      this.switchValue = true;

      // 重置兑换页配置分页
      this.exchangePageParams = {
        page: 1,
        limit: 10
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    // 处理图片加载错误
    handleImageError: function handleImageError(e) {
      console.error('Image failed to load:', e);
      e.target.src = ''; // 清空错误图片
      this.$message.error('图片加载失败，请重新上传');
    },
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this2 = this;
      this.$modalUpload(function (img) {
        if (img && img.length > 0 && img[0].sattDir) {
          _this2.form.cardStyle = img[0].sattDir;
        }
      }, tit, 'welfareCard');
    },
    // 移除图片 - 清除图片路径
    removeImg: function removeImg(dataIndex) {
      console.log('Removing image from:', dataIndex);
      this.form.cardStyle = '';
    },
    // 处理cardIds数据并确保它们是数字类型
    processCardIds: function processCardIds(cardIds) {
      if (!cardIds) return [];
      if (!Array.isArray(cardIds)) return [];

      // 确保所有ID都是数字类型
      return cardIds.map(function (id) {
        return Number(id);
      });
    },
    // 旧的图片上传方法保留但不使用
    handleCardImageChange: function handleCardImageChange(file) {
      // 在实际项目中，这里应该处理图片上传到服务器
      // 这里暂时只是本地预览
      this.form.cardStyle = URL.createObjectURL(file.raw);
    },
    // Add method to load card data for filtering
    loadCardFilter: function loadCardFilter() {
      this.fetchCards();
      if (this.getCardList) {
        this.getCardList();
      }
    },
    // 添加一个辅助函数来根据ID查找卡片
    findCardById: function findCardById(id) {
      // 确保ID是数字类型
      var numericId = Number(id);

      // 尝试从本地卡片列表中查找
      var foundCard = this.localCardList.find(function (card) {
        return Number(card.id) === numericId;
      });

      // 如果没找到，尝试从cardList中查找
      if (!foundCard && Array.isArray(this.cardList)) {
        foundCard = this.cardList.find(function (card) {
          return Number(card.id) === numericId;
        });
      }
      return foundCard || {
        id: numericId,
        name: "\u5361\u7247".concat(numericId)
      };
    },
    // 获取处理后的图片URL，确保图片能够正确显示
    getProcessedImageUrl: function getProcessedImageUrl(url) {
      console.log('Processing image URL:', url);
      if (!url) return '';

      // 检查URL是否已经是完整的URL
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 如果是相对路径，则添加基础URL
      return "https://hhzb-cos-1317915528.cos.ap-chengdu.myqcloud.com/".concat(url);
    },
    // 搜索兑换页配置
    searchExchangeConfigs: function () {
      var _searchExchangeConfigs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(query) {
        var params, res, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.exchangeConfigsLoading = true;
              _context4.p = 1;
              params = _objectSpread(_objectSpread({}, this.exchangePageParams), {}, {
                keyword: query || undefined
              });
              _context4.n = 2;
              return (0, _api.getExchangePageConfigsApi)(params);
            case 2:
              res = _context4.v;
              if (res && res.list) {
                // 将选项格式设置为"ID-名称"
                this.exchangePageOptions = res.list.map(function (item) {
                  return {
                    label: "".concat(item.name),
                    value: item.id
                  };
                });
                this.exchangePageTotal = res.total || 0;
              }
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.error('Error searching exchange configs:', _t4);
            case 4:
              _context4.p = 4;
              this.exchangeConfigsLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function searchExchangeConfigs(_x2) {
        return _searchExchangeConfigs.apply(this, arguments);
      }
      return searchExchangeConfigs;
    }(),
    // 加载兑换页配置
    loadExchangeConfigs: function () {
      var _loadExchangeConfigs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.searchExchangeConfigs('');
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function loadExchangeConfigs() {
        return _loadExchangeConfigs.apply(this, arguments);
      }
      return loadExchangeConfigs;
    }(),
    // 兑换页配置分页变化
    handleExchangePageChange: function () {
      var _handleExchangePageChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(page) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.exchangePageParams.page = page;
              _context6.n = 1;
              return this.searchExchangeConfigs('');
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function handleExchangePageChange(_x3) {
        return _handleExchangePageChange.apply(this, arguments);
      }
      return handleExchangePageChange;
    }(),
    // 提交表单
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this3 = this;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(valid) {
                  var formData, res, _t5;
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.p = _context7.n) {
                      case 0:
                        if (valid) {
                          _context7.n = 1;
                          break;
                        }
                        return _context7.a(2);
                      case 1:
                        _context7.p = 1;
                        _this3.loading = true;

                        // 转换表单数据为后端需要的格式 (CardPackageRequest)
                        formData = {
                          id: _this3.form.id || null,
                          name: _this3.form.name,
                          internalName: _this3.form.internalName,
                          status: _this3.switchValue ? 1 : 0,
                          // 使用开关状态设置status
                          usageDesc: _this3.form.usageDesc,
                          cardIds: _this3.form.cardIds,
                          themeColor: _this3.form.themeColor,
                          cardStyle: _this3.form.cardStyle,
                          exchangeConfigId: _this3.form.exchangeConfigId || null
                        }; // 调用接口
                        if (!formData.id) {
                          _context7.n = 3;
                          break;
                        }
                        _context7.n = 2;
                        return (0, _api.updateApi)(formData);
                      case 2:
                        res = _context7.v;
                        _this3.$message.success('编辑成功');
                        _this3.handleClose();
                        _this3.getList();
                        _context7.n = 5;
                        break;
                      case 3:
                        _context7.n = 4;
                        return (0, _api.createApi)(formData);
                      case 4:
                        res = _context7.v;
                        _this3.$message.success('新增成功');
                        _this3.handleClose();
                        _this3.getList();
                      case 5:
                        _context7.n = 7;
                        break;
                      case 6:
                        _context7.p = 6;
                        _t5 = _context7.v;
                        console.error('保存失败', _t5);
                        _this3.$message.error('保存失败');
                      case 7:
                        _context7.p = 7;
                        _this3.loading = false;
                        return _context7.f(7);
                      case 8:
                        return _context7.a(2);
                    }
                  }, _callee7, null, [[1, 6, 7, 8]]);
                }));
                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function submitForm() {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }()
  }),
  mixins: [_effect.default]
};